import { MyAccountTheme, MaCustomDividerClasses } from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const customDividerStyles = makeStyles<
  MyAccountTheme,
  object,
  MaCustomDividerClasses
>(
  () => ({
    root: {
      margin: '10px 0',
    },
  }),
  { name: 'MyOrders_CustomDivider' }
)

export default customDividerStyles
